import { render, staticRenderFns } from "./Qna.vue?vue&type=template&id=a1fbc0e8&scoped=true&"
import script from "./Qna.vue?vue&type=script&lang=js&"
export * from "./Qna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fbc0e8",
  null
  
)

export default component.exports